module.exports = __webpack_public_path__ + "static/media/wallet.06604d59.svg";